import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, MessageCircle, ChevronDown, ChevronUp, ExternalLink, HelpCircle, MessageSquare } from 'lucide-react';
import '../pages/ScanPoints.css';

const HelpCenter = () => {
    const navigate = useNavigate();
    const [openFaq, setOpenFaq] = useState(null);

    // Valeurs par défaut (à connecter au backend plus tard si nécessaire)
    const whatsappNumber = "21699000000"; // Exemple de numéro
    const faqs = [
        {
            question: "Comment gagner des points ?",
            answer: "Vous gagnez des points en scannant votre QR code lors de vos achats chez nos partenaires ou en saisissant les codes manuellement."
        },
        {
            question: "Où puis-je utiliser mes récompenses ?",
            answer: "Vos récompenses sont valables dans tous les points de vente participants affichés dans l'onglet 'Cadeaux'."
        },
        {
            question: "Mes points expirent-ils ?",
            answer: "Vos points sont valables pendant 12 mois à compter de leur date d'acquisition."
        },
        {
            question: "Comment contacter le support ?",
            answer: "Vous pouvez nous contacter directement via WhatsApp en cliquant sur le bouton ci-dessous pour une assistance en direct."
        }
    ];

    const handleWhatsApp = () => {
        window.open(`https://wa.me/${whatsappNumber.replace('+', '')}`, '_blank');
    };

    return (
        <div className="mobile-app-container" style={{ background: '#f8f9fe', minHeight: '100vh' }}>
            {/* Header Mobile Natif */}
            <header style={{
                position: 'sticky',
                top: 0,
                padding: '1.25rem 1.5rem',
                background: 'white',
                borderBottom: '1px solid rgba(0,0,0,0.05)',
                zIndex: 100,
                display: 'flex',
                alignItems: 'center',
                gap: '1rem'
            }}>
                <button
                    onClick={() => navigate(-1)}
                    style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '12px',
                        backgroundColor: '#f1f5f9',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: 'none',
                        color: '#1e293b',
                        cursor: 'pointer'
                    }}
                >
                    <ArrowLeft size={20} />
                </button>
                <h1 style={{ fontSize: '1.25rem', fontWeight: '800', color: '#1e293b', margin: 0 }}>
                    Centre d'aide
                </h1>
            </header>

            <main className="mobile-main-feed animate-fade-in" style={{ padding: '1.5rem' }}>
                {/* Intro Section */}
                <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
                    <div style={{
                        width: '70px',
                        height: '70px',
                        background: 'rgba(99, 102, 241, 0.1)',
                        borderRadius: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#6366f1',
                        margin: '0 auto 1rem'
                    }}>
                        <HelpCircle size={32} />
                    </div>
                    <h2 style={{ fontSize: '1.5rem', fontWeight: '800', color: '#1e293b', marginBottom: '0.5rem' }}>Comment pouvons-nous vous aider ?</h2>
                    <p style={{ color: '#64748b', fontSize: '0.9rem' }}>Consultez nos questions fréquentes ou discutez avec nous sur WhatsApp.</p>
                </div>

                {/* WhatsApp Contact Card */}
                <div
                    onClick={handleWhatsApp}
                    style={{
                        background: '#25D366',
                        borderRadius: '24px',
                        padding: '1.5rem',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '1rem',
                        marginBottom: '2.5rem',
                        boxShadow: '0 10px 25px rgba(37, 211, 102, 0.25)',
                        cursor: 'pointer',
                        transition: 'transform 0.2s'
                    }}
                >
                    <div style={{ background: 'rgba(255,255,255,0.2)', padding: '12px', borderRadius: '16px' }}>
                        <MessageCircle size={28} />
                    </div>
                    <div style={{ flex: 1 }}>
                        <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: '800' }}>Discuter sur WhatsApp</h3>
                        <p style={{ margin: 0, fontSize: '0.85rem', opacity: 0.9 }}>Une question ? Réponse directe</p>
                    </div>
                    <ExternalLink size={20} style={{ opacity: 0.7 }} />
                </div>

                {/* FAQ Section */}
                <div style={{ marginBottom: '1.5rem' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '1rem' }}>
                        <MessageSquare size={18} style={{ color: '#6366f1' }} />
                        <h3 style={{ margin: 0, fontSize: '1rem', fontWeight: '800', color: '#334155', textTransform: 'uppercase', letterSpacing: '1px' }}>
                            Questions Fréquentes
                        </h3>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                        {faqs.map((faq, index) => (
                            <div
                                key={index}
                                style={{
                                    background: 'white',
                                    borderRadius: '16px',
                                    border: '1px solid rgba(0,0,0,0.03)',
                                    overflow: 'hidden'
                                }}
                            >
                                <button
                                    onClick={() => setOpenFaq(openFaq === index ? null : index)}
                                    style={{
                                        width: '100%',
                                        padding: '1.25rem',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        background: 'none',
                                        border: 'none',
                                        textAlign: 'left',
                                        cursor: 'pointer'
                                    }}
                                >
                                    <span style={{ fontSize: '0.95rem', fontWeight: '700', color: '#1e293b', flex: 1, paddingRight: '1rem' }}>
                                        {faq.question}
                                    </span>
                                    {openFaq === index ? <ChevronUp size={20} color="#94a3b8" /> : <ChevronDown size={20} color="#94a3b8" />}
                                </button>

                                {openFaq === index && (
                                    <div style={{
                                        padding: '0 1.25rem 1.25rem',
                                        color: '#64748b',
                                        fontSize: '0.9rem',
                                        lineHeight: '1.6',
                                        borderTop: '1px solid #f8fafc'
                                    }}>
                                        {faq.answer}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                <div className="pb-10"></div>
            </main>
        </div>
    );
};

export default HelpCenter;
